import { ReactNode } from "react"
import "./CardReports.css"

const CardReports = ({ children, height }: { children: ReactNode, height?: string }) => {
    return <div className="card-reports" style={{ height }}>{children}</div>
}

export default CardReports
